import { ONE_MINUTE_MS } from '../constants/time';
export const getMinutesDiffFromDates = (d1, d2) => {
    return Math.floor(d2.getTime() / ONE_MINUTE_MS) - Math.floor(d1.getTime() / ONE_MINUTE_MS);
};
export const minutesToHumanHoursMinutes = (minutesDiff) => {
    const hours = Math.floor(minutesDiff / 60);
    const minutes = minutesDiff % 60;
    return `${hours.toString()}:${minutes.toString().padStart(2, '0')}`;
};
export const getDatesOverlap = (start1, end1, start2, end2) => {
    const isBefore = start1 < start2 && end1 <= start2;
    const isAfter = start1 >= end2 && end1 > end2;
    return !(isBefore || isAfter);
};
export const toDateStringShort = (date) => {
    return date.toLocaleDateString('en-GB', { timeZone: 'Etc/UTC' }).substr(0, 5);
};
export const toTimeStringShort = (date, timeZone) => {
    timeZone = timeZone || 'Etc/UTC';
    return date.toLocaleTimeString('en-GB', { timeZone }).substr(0, 5);
};
//# sourceMappingURL=time.js.map